import { render, staticRenderFns } from "./img-biaozhu.vue?vue&type=template&id=deb2fdc0&scoped=true"
import script from "./img-biaozhu.vue?vue&type=script&lang=ts"
export * from "./img-biaozhu.vue?vue&type=script&lang=ts"
import style0 from "./img-biaozhu.vue?vue&type=style&index=0&id=deb2fdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb2fdc0",
  null
  
)

export default component.exports